<template>
  <div class="pa-4">
    <h1>aggrid表格封装</h1>
    <VritualGrid
      ref="grid"
      a="1"
      b="2"
      c="3"
      styles="height: 100px;border: 1px solid lightblue;"
      style="height: 600px;"
      class="pa-1"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
  </div>
</template>
<script>
import VritualGrid from '@/components/common/VritualGrid.vue';

export default {
  components: {
    VritualGrid
  },

  data() {
    return {
      columnDefs: [
        { field: "make", flex: 1 },
        { field: "model" },
        { field: "price" },
      ],
      rowData: [
        { make: "Toyota", model: "Celica", price: 35000 },
        { make: "Ford", model: "Mondeo", price: 32000 },
        { make: "Porsche", model: "Boxster", price: 72000 },
      ],
    }
  },


  mounted() {
    setTimeout(() => {
      this.columnDefs = [
      {
        field: "make",
        filter: 'agTextColumnFilter',
      },
      {
        field: "model",
        // filter: 'agTextColumnFilter',
      },
      {
        field: "price",
        filter: 'agNumberColumnFilter',
      },
    ];


    this.rowData = [
      { make: "1Toyota", model: "Celica", price: 35000 },
      { make: "2Ford", model: "Mondeo", price: 32000 },
      { make: "3Porsche", model: "Boxster", price: 72000 },
      { make: "4Toyota", model: "Celica", price: 35000 },
      { make: "5Ford", model: "Mondeo", price: 32000 },
      { make: "6Porsche", model: "Boxster", price: 72000 },
      { make: "7Toyota", model: "Celica", price: 35000 },
      { make: "8Ford", model: "Mondeo", price: 32000 },
      { make: "9Porsche", model: "Boxster", price: 72000 },
      { make: "10Toyota", model: "Celica", price: 35000 },
      { make: "11Ford", model: "Mondeo", price: 32000 },
      { make: "12Porsche", model: "Boxster", price: 72000 },
      { make: "13Toyota", model: "Celica", price: 35000 },
      { make: "14Ford", model: "Mondeo", price: 32000 },
      { make: "15Porsche", model: "Boxster", price: 72000 },
      { make: "16Toyota", model: "Celica", price: 35000 },
      { make: "17Ford", model: "Mondeo", price: 32000 },
      { make: "18Porsche", model: "Boxster", price: 72000 },
    ];
    }, 3000);
  },
}
</script>